<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<form [formGroup]="chargeBackFormGroup" (submit)="openConfirmDialog()">
  <div class="offset-md-3 col-md-6 row mb-3 mt-4">
    <h2 class="col-md-6 m-auto">Collect Chargeback</h2>
    <div class="col-md-5">
      <button
        type="button"
        class="btn btn-warning float-right"
        (click)="clearValues()"
      >
        <span>
          <fa-icon [icon]="faEraser"></fa-icon>
        </span>
        Clear Values
      </button>
    </div>
  </div>
  <div class="offset-md-4 mb-5">
    <fieldset [disabled]="failedGlobalConfig">
      <div class="form-group fieldIsRequired">
        <label class="col-md-4"> Original Transaction ID </label>
        <div class="col-md-6">
          <input
            formControlName="transactionId"
            class="form-control"
            [ngClass]="{
              'is-invalid':
                chargeBackFormGroup.controls.transactionId.invalid &&
                (chargeBackFormGroup.controls.transactionId.dirty ||
                  chargeBackFormGroup.controls.transactionId.touched)
            }"
          />
          <div
            *ngIf="
              chargeBackFormGroup.controls.transactionId.invalid &&
              (chargeBackFormGroup.controls.transactionId.dirty ||
                chargeBackFormGroup.controls.transactionId.touched)
            "
            class="mt-1"
          >
            <div
              class="text-danger"
              *ngIf="
                chargeBackFormGroup.controls.transactionId.errors?.required
              "
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="
                chargeBackFormGroup.controls.transactionId.errors?.minlength
              "
            >
              TransactionID must be at least 8 numbers
            </div>
            <div
              class="text-danger"
              *ngIf="chargeBackFormGroup.controls.transactionId.errors?.pattern"
            >
              Transaction Id must be a number
            </div>
          </div>
        </div>
      </div>
      <div class="form-group fieldIsRequired">
        <label class="col-md-4"> Original Order ID </label>
        <div class="col-md-6">
          <input
            formControlName="orderId"
            class="form-control"
            [ngClass]="{
              'is-invalid':
                chargeBackFormGroup.controls.orderId.invalid &&
                (chargeBackFormGroup.controls.orderId.dirty ||
                  chargeBackFormGroup.controls.orderId.touched)
            }"
          />
          <div
            *ngIf="
              chargeBackFormGroup.controls.orderId.invalid &&
              (chargeBackFormGroup.controls.orderId.dirty ||
                chargeBackFormGroup.controls.orderId.touched)
            "
            class="mt-1"
          >
            <div
              class="text-danger"
              *ngIf="chargeBackFormGroup.controls.orderId.errors?.required"
            >
              Field is required.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group fieldIsRequired">
        <label class="col-md-4"> Chargeback Amount </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dollarAddAuthFee">$</span>
            <input
              formControlName="amount"
              aria-describedby="dollarAddOn"
              class="form-control text-right"
              placeholder="0.00"
              (input)="calculateTotal($event)"
              [ngClass]="{
                'is-invalid':
                  chargeBackFormGroup.controls.amount.invalid &&
                  (chargeBackFormGroup.controls.amount.dirty ||
                    chargeBackFormGroup.controls.amount.touched)
              }"
            />
            <div class="row ml-1">
              <div
                *ngIf="
                  chargeBackFormGroup.controls.amount.invalid &&
                  (chargeBackFormGroup.controls.amount.dirty ||
                    chargeBackFormGroup.controls.amount.touched)
                "
                class="mt-1"
              >
                <div
                  class="text-danger"
                  *ngIf="chargeBackFormGroup.controls.amount.errors?.required"
                >
                  Field is required.
                </div>
                <div
                  class="text-danger"
                  *ngIf="chargeBackFormGroup.controls.amount.errors?.pattern"
                >
                  Please enter a valid dollar amount.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row col-md-6 money-line">
        <div class="col-md-6">Chargeback Fee</div>
        <div class="col-md-6 money-text text-right">
          {{ fee | currency }}
        </div>
      </div>
      <div class="col-md-6">
        <hr />
      </div>

      <div class="row col-md-6 money-line">
        <div class="col-md-6">
          <b>Total</b>
        </div>
        <div class="col-md-6 text-right money-text">
          <b>{{ total | currency }}</b>
        </div>
      </div>
    </fieldset>
  </div>

  <div class="offset-md-4 col-md-6">
    <app-edit-buttons
      [buttonName]="buttonName"
      [actionInProgress]="actionInProgress"
      [formInvalid]="chargeBackFormGroup.invalid"
      (editableEvent)="receiveEditEvent($event)"
    >
    </app-edit-buttons>
  </div>
</form>
